module.exports = __webpack_public_path__ + "static/media/map-marker-minus.3fcb9a10.svg";